export function semicolonJoin(arr) {
  return arr.join("; ");
}

export function semicolonSplit(arr) {
  return arr.split("; ");
}
